export default __webpack_public_path__ + "static/media/AppStore.8c4986ee.svg";